<template>
  <b-container fluid>
    <div>
      <b-overlay :show="loader">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title text-center">{{ $t('social_service.dashbboard') }}</h4>
          </template>
          <template v-slot:body>
            <b-row>
              <b-col xl="12" lg="12" sm="12">
                <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                  <b-form @submit.prevent="handleSubmit(storeUpdate)" @reset.prevent="reset" enctype="multipart/form-data">
                    <b-row>
                      <b-col lg="4" sm="12">
                        <ValidationProvider name="Fiscal Year" vid="fiscal_year_id">
                          <b-form-group
                              class="row"
                              label-cols-sm="4"
                              :label="$t('globalTrans.fiscal_year')"
                              label-for="fiscal_year_id"
                              slot-scope="{ valid, errors }"
                          >
                            <b-form-select
                                plain
                                v-model="search.fiscal_year_id"
                                :options="fiscalYearList"
                                id="fiscal_year_id"
                                :state="errors[0] ? false : (valid ? true : null)"
                            >
                              <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                              </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>
                      <b-col lg="4" sm="12">
                        <ValidationProvider name="IDSC Center" vid="center_id">
                          <b-form-group
                              class="row"
                              label-cols-sm="4"
                              label-for="center_id"
                              slot-scope="{ valid, errors }"
                          >
                            <template v-slot:label>
                              {{$t('assitive_device_management.idsc_center_name')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                                plain
                                v-model="search.center_id"
                                id="center_id"
                                :options="idscCenterList"
                                :state="errors[0] ? false : (valid ? true : null)"
                                :disabled="activeCenter.value"
                            >
                              <template v-slot:first>
                                <b-form-select-option value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                              </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>
                      <b-col lg="4" sm="12">
                        <ValidationProvider name="Assistive Device" vid="assistive_device_id">
                          <b-form-group
                              class="row"
                              label-cols-sm="4"
                              label-for="assistive_device_id"
                              slot-scope="{ valid, errors }"
                          >
                            <template v-slot:label>
                              {{ $t('assitive_device_management.device_name') }} <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                                plain
                                id="assistive_device_id"
                                v-model="search.assistive_device_id"
                                :options="assistiveDeviceList"
                                :state="errors[0] ? false : (valid ? true : null)"
                            >
                              <template v-slot:first>
                                <b-form-select-option value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                              </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>
                      <b-col lg="4" sm="12">
                        <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>
                      </b-col>
                    </b-row>
                  </b-form>
                </ValidationObserver>
              </b-col>
            </b-row>
            <div class="ministry_wrapper">
              <div class="accordion mb-0">
                <div class="accordion-item mb-0">
                  <div class="accordion-body my-4 px-2" style="padding: 0;border-radius: 8px 8px 8px 8px;">
                    <b-row>
                      <b-col sm="4">
                        <div class="license_card_item_wrapper production_wrapper my-4">
                          <div class="item_1">
                            <img src="../../assets/images/ministry-dashboard/total-application-o.svg" class="item_icon img-fluid">
                            <h2 class="count production_count">{{ $n(total_patients) }}</h2>
                          </div>
                          <div class="item_2 total">
                            <p class="title">{{ $t('awareness_dashboard.no_of_beneficiaries_disable_person') }}</p>
                          </div>
                        </div>
                      </b-col>
                      <b-col sm="4">
                        <div class="license_card_item_wrapper allocation_wrapper my-4">
                          <div class="item_1">
                            <img src="../../assets/images/ministry-dashboard/farmer.svg" class="item_icon img-fluid">
                            <h2 class="count production_count" style="color:#8CC34B">{{ $n(total_device_demand) }}</h2>
                          </div>
                          <div class="item_2 approved">
                            <p class="title">{{ $t('awareness_dashboard.device_demand') }}</p>
                          </div>
                        </div>
                      </b-col>
                      <b-col sm="4">
                        <div class="license_card_item_wrapper sale_wrapper my-4">
                          <div class="item_1">
                            <img src="../../assets/images/ministry-dashboard/user.svg" class="item_icon img-fluid">
                            <h2 class="count production_count" style="color:#00bcd5">{{ $n(total_device_distribution) }}</h2>
                          </div>
                          <div class="item_2 pending">
                            <p class="title">{{ $t('awareness_dashboard.device_distribution') }}</p>
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </div>
            </div>
            <b-row>
              <b-col md="12">
                <iq-card style="box-shadow: rgb(0 0 0 / 24%) 0px 3px 8px">
                  <h5 class="card-title text-center text-bold pt-3" style="color: #424242 !important;">{{ $t('awareness_dashboard.no_of_beneficiaries_disable_person') }}</h5>
                  <apexchart type="bar" height="350" :options="patientChartOptions" :series="patientSeries"></apexchart>
                </iq-card>
                <b-row>
                  <b-col lg="12">
                    <iq-card style="box-shadow: rgb(0 0 0 / 24%) 0px 3px 8px">
                      <h5 class="card-title text-center text-bold pt-3" style="color: #424242 !important;">{{ $t('awareness_dashboard.device_demand_distribution') }}</h5>
                      <apexchart type="bar" height="430" :options="deviceChartOptions" :series="deviceSeries"></apexchart>
                    </iq-card>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-overlay>
    </div>
  </b-container>
</template>
<script>
import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import apexchart from 'vue-apexcharts'
import Vue from 'vue'
Vue.use(apexchart)

export default {
  mixins: [ModalBaseMasterList],
  components: {
    apexchart
  },
  data () {
    return {
      loader: false,
      search: {
        fiscal_year_id: 0,
        center_id: 0,
        assistive_device_id: 0
      },
      total_patients: 0,
      total_device_demand: 0,
      total_device_distribution: 0,
      activeCenter: {
        value: 0
      },
      patientSeries: [{
        data: []
      }],
      patientChartOptions: {
        chart: {
          type: 'bar',
          height: 350
        },
        plotOptions: {
          bar: {
            columnWidth: '10px',
            borderRadius: 4,
            horizontal: false
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        }
      },
      deviceSeries: [{
        name: 'Assistive Device Demand',
        data: []
      }, {
        name: 'Assistive Device Distribution',
        data: []
      }],
      deviceChartOptions: {
        chart: {
          type: 'bar',
          height: 430
        },
        colors: ['#5C9BD5', '#ED7E30'],
        plotOptions: {
          bar: {
            columnWidth: '20px',
            horizontal: false,
            dataLabels: {
              position: 'top'
            }
          }
        },
        dataLabels: {
          enabled: true,
          offsetX: -6,
          style: {
            fontSize: '12px',
            colors: ['#fff']
          }
        },
        stroke: {
          show: true,
          width: 1,
          colors: ['#fff']
        },
        tooltip: {
          shared: true,
          intersect: false
        },
        xaxis: {
          categories: []
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          // customLegendItems: ['Assistive Device Demand', 'Assistive Device Distribution'],
          markers: {
            fillColors: ['#5C9BD5', '#ED7E30']
          }
        }
      }
    }
  },
  computed: {
    fiscalYearList: function () {
      return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
    },
    assistiveDeviceList: function () {
      return this.$store.state.AwarenessEventService.commonObj.assistiveDeviceList.filter(item => item.status === 1)
    },
    idscCenterList: function () {
      return this.$store.state.AwarenessEventService.commonObj.idscCenterList.filter(item => item.status === 1 && item.org_id === 3 && item.sales_center_type === 1)
    }
  },
  watch: {
  },
  created () {
      this.search = Object.assign({}, this.search, { fiscal_year_id: this.$store.state.currentFiscalYearId })
      if (this.$store.state.dataFilters.officeId) {
        const centerOfficeId = this.$store.state.dataFilters.officeId
        this.activeCenter = this.idscCenterList.find(item => item.office_id === parseInt(centerOfficeId))
        this.search = Object.assign({}, this.search, {
            center_id: this.activeCenter.value
        })
      }
    this.loadData()
  },
  methods: {
    searchData () {
      this.loadData()
    },
    async loadData () {
      this.loader = true
      this.total_patients = 0
      this.total_device_demand = 0
      this.total_device_distribution = 0
      this.$set(this.patientSeries, 0, { data: [] })
      this.patientChartOptions = Object.assign({}, this.patientChartOptions, {
        xaxis: {
          categories: []
        }
      })
      let lebel1 = []
      let lebel2 = []
      if (this.$i18n.locale === 'bn') {
          lebel1 = 'সহায়ক উপকরণের চাহিদা'
          lebel2 = 'সহায়ক উপকরণ বিতরণ'
        } else {
          lebel1 = 'Assistive Device Demand'
          lebel2 = 'Assistive Device Distribution'
        }
      this.$set(this.deviceSeries, 0, { name: lebel1, data: [] })
      this.$set(this.deviceSeries, 1, { name: lebel2, data: [] })
      this.deviceChartOptions = Object.assign({}, this.deviceChartOptions, {
        xaxis: {
          categories: []
        }
      })
      const result = await RestApi.getData(awarenessEventServiceBaseUrl, 'dashboard', this.search)
      if (result.success) {
        this.total_patients = result.data.total_patients
        this.total_device_demand = result.data.total_device_demand
        this.total_device_distribution = result.data.total_device_distribution
        const patientSeriesData = []
        const patientCategoriesData = []
        result.data.patientInfo.forEach(item => {
          const date = new Date(item.registration_year, item.registration_month, 1)
          let shortMonth = []
          if (this.$i18n.locale === 'bn') {
            shortMonth = date.toLocaleString('bn-bd', { month: 'short' })
          } else {
            shortMonth = date.toLocaleString('en-us', { month: 'short' })
          }
          // const shortMonth = date.toLocaleString('en-us', { month: 'short' })
          const shortYear = item.registration_year.toString().substring(2)
          const monthYear = shortMonth + '-' + this.$n(shortYear, { useGrouping: false })
          patientSeriesData.push(item.total_patient)
          patientCategoriesData.push(monthYear)
        })
        const deviceDemandData = []
        const deviceDistributionData = []
        const deviceCategoriesData = []
        result.data.deviceDemandDistributionInfo.forEach(item => {
          const fiscalYear = this.fiscalYearList.find(obj => obj.value === parseInt(item.fiscal_year_id))
          if (this.$i18n.locale === 'bn') {
            deviceCategoriesData.push(fiscalYear?.text_bn)
          } else {
            deviceCategoriesData.push(fiscalYear?.text_en)
          }
          const totalDeviceDemand = item.total_device_demand
          const totalDeviceDistribution = item.total_device_distribution
          deviceDemandData.push(totalDeviceDemand)
          deviceDistributionData.push(totalDeviceDistribution)
        })
        this.$nextTick(() => {
          this.$set(this.patientSeries, 0, { data: patientSeriesData })
          this.patientChartOptions = Object.assign({}, this.patientChartOptions, {
            xaxis: {
              categories: patientCategoriesData
            }
          })
          let lebel1 = []
          let lebel2 = []
          if (this.$i18n.locale === 'bn') {
            lebel1 = 'সহায়ক উপকরণের চাহিদা'
            lebel2 = 'সহায়ক উপকরণ বিতরণ'
          } else {
            lebel1 = 'Assistive Device Demand'
            lebel2 = 'Assistive Device Distribution'
          }
          this.$set(this.deviceSeries, 0, { name: lebel1, data: deviceDemandData })
          this.$set(this.deviceSeries, 1, { name: lebel2, data: deviceDistributionData })
          this.deviceChartOptions = Object.assign({}, this.deviceChartOptions, {
            xaxis: {
              categories: deviceCategoriesData
            }
          })
        })
        this.loader = false
      } else {
        this.total_patients = 0
        this.total_device_demand = 0
        this.total_device_distribution = 0
        this.$set(this.patientSeries, 0, { data: [] })
        this.patientChartOptions = Object.assign({}, this.patientChartOptions, {
          xaxis: {
            categories: []
          }
        })
        this.$set(this.deviceSeries, 0, { name: 'Assistive Device Demand', data: [] })
        this.$set(this.deviceSeries, 1, { name: 'Assistive Device Distribution', data: [] })
        this.deviceChartOptions = Object.assign({}, this.deviceChartOptions, {
          xaxis: {
            categories: []
          }
        })
        this.loader = false
      }
    }
  }
}
</script>
